.card {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm, 8px);
}

.row {
  display: inline-flex;
  gap: var(--spacing-sm, 8px);
  align-items: baseline;
  flex-wrap: wrap;
}

.label {
  margin: 0;
  font-size: var(--font-size-sm, 14px);
  color: var(--text-secondary, #666);
}

.chordName {
  margin: 0;
  font-size: var(--font-size-md, 18px);
  font-weight: 600;
  font-family: var(--font-family-mono, ui-monospace, monospace);
}

.whyButton {
  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);
  background: transparent;
  border: var(--border-width, 1px) solid var(--border-color, #ccc);
  border-radius: var(--radius-sm, 4px);
  cursor: pointer;
  min-height: 44px;
}
